import {UiSchema}         from "../@types";
import {text}             from "./text";
import {number}           from "./number";
import {select}           from "./select";
import {edit}             from "./edit";
import {ActionButtonCell} from "./action-button";
import {DateCell}         from "./date";
import {DateTimeCell}     from "./date-time";
import {FromToDateCell}   from "./from-to-date";
import {IconDataCell}     from "./icon-text";
import {IconDataListCell} from "./icon-text-list";
import {LinkCell}         from "./link";

const defaultUiSchema: UiSchema = {
    select,
    edit,
    text,
    number,
    ActionButtonCell,
    DateCell,
    DateTimeCell,
    FromToDateCell,
    IconDataCell,
    IconDataListCell,
    LinkCell,
    default: text,
}

export {defaultUiSchema}
